"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const chart_helpers_1 = require("../../util/chart.helpers");
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
require("./Sankey.scss");
const RightSankey_1 = __importDefault(require("./RightSankey"));
const LeftSankey_1 = __importDefault(require("./LeftSankey"));
const format_1 = require("../../util/format");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const constants_1 = require("../../constants");
const error_1 = require("../error");
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const DEFAULT_WIDTH = 1000;
const DEFAULT_HEIGHT = 700;
class SankeyDiagram {
  constructor(container) {
    this.chartType = constants_1.CHART_TYPES.Sankey;
    this.cssPrefix = 'sankey';
    this.container = container.classed('sankey', true).classed('dh-chart-wrapper', true);
    this.margins = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    this.svg = this.container.append('svg');
    this.sourceContainer = container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    this.initPattern();
    error_1.initError.call(this);
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth,
          height: containerHeight
        } = entry.contentRect;
        requestAnimationFrame(() => {
          if ((this === null || this === void 0 ? void 0 : this.width) !== containerWidth) {
            this.svg.attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`);
            this.resizeContent(containerWidth, containerHeight);
          }
        });
      });
    });
    this.ro.observe(container.node());
  }
  initPattern() {
    const defs = this.svg.append('defs');
    const diagonalPattern = defs.append('pattern').attr('id', 'sankey-pattern-diagonal').attr('patternUnits', 'userSpaceOnUse').attr('width', 8).attr('height', 8);
    diagonalPattern.append('path').attr('d', 'M-1,1 l2,-2 M0,8 l8,-8 M7,9 l2,-2').style('stroke', 'white').style('stroke-width', 1);
    const diagonalMask = defs.append('mask').attr('id', 'sankey-mask-diagonal').attr('x', 0).attr('y', 0).attr('width', 1).attr('height', 1);
    diagonalMask.append('rect').attr('x', 0).attr('y', 0).attr('width', 5000).attr('height', 5000).attr('fill', 'url(#sankey-pattern-diagonal)');
  }
  static createScales(drawParams) {
    const {
      data,
      params
    } = drawParams;
    const maxSankeyRoot = Math.max(data.metric[params.leftSankey] ? data.metric[params.leftSankey].total : 0, data.metric[params.rightSankey] ? data.metric[params.rightSankey].total : 0);
    const heightScale = d3.scaleLinear().domain([0, maxSankeyRoot]).range([0, params.rootHeight]);
    return {
      heightScale
    };
  }
  async data(promises) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    return {
      data: fetched.data
    };
  }
  getDrawParams(_ref) {
    let {
      data,
      options
    } = _ref;
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        options
      }, this.margins),
      titleFontSize: Object.prototype.hasOwnProperty.call(options, 'titleFontSize') ? options.titleFontSize : null,
      // required
      leftSankey: options.leftSankey,
      rightSankey: options.rightSankey,
      extraName: Object.prototype.hasOwnProperty.call(options, 'extraName') ? options.extraName : '',
      primaryColor: options.primaryColor || colours_module_scss_1.default.chartcolourdefault0,
      secondaryColor: options.secondaryColor || colours_module_scss_1.default.chartcolourdefault3,
      primaryTitleColor: options.primaryTitleColor || options.primaryColor || colours_module_scss_1.default.chartcolourdefault0,
      secondaryTitleColor: options.secondaryTitleColor || options.secondaryColor || colours_module_scss_1.default.chartcolourdefault3,
      labelColor: options.labelColor || null,
      rootHeight: options.rootHeight || 500,
      containerWidth: options.containerWidth || DEFAULT_WIDTH,
      containerHeight: options.containerHeight || DEFAULT_HEIGHT,
      rootHeightToSankeyHeightRatio: options.rootHeightToSankeyHeightRatio,
      showSourcesAndFootnotes: options.showSourcesAndFootnotes
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data: datas
    } = allData;
    const optionParams = this.getDrawParams({
      data: datas,
      options
    });
    const drawParams = {
      data: datas[0],
      params: optionParams
    };
    const {
      height: containerHeight,
      width: containerWidth
    } = this.container.node().getBoundingClientRect();
    this.drawContent(drawParams, containerWidth, containerHeight);
    return true;
  }
  resizeContent(width, height) {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams, width, height);
    }
  }
  drawContent(drawParams) {
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_WIDTH;
    let height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_HEIGHT;
    const {
      data,
      params
    } = drawParams;
    if (params.showSourcesAndFootnotes) {
      this.sources.draw([data], params);
    }
    this.width = width;
    const {
      height: footerHeight
    } = this.sourceContainer.node().getBoundingClientRect();
    if (params.rootHeightToSankeyHeightRatio) {
      params.rootHeight = (height - 50 - footerHeight) * params.rootHeightToSankeyHeightRatio;
    }
    this.cachedParams = drawParams;
    const numSankeys = lodash_1.default.compact([params.leftSankey, params.rightSankey]).length;
    if (numSankeys < 1) {
      console.warn('leftSankey and rightSankey were not specified; not drawing anything');
      return;
    }
    this.heightScale = SankeyDiagram.createScales(drawParams).heightScale;
    this.svg.selectAll('g').remove();
    this.svg.append('g').classed('sankey-title', true).attr('transform', `translate(${width * 0.5}, 0)`).append('text').attr('dy', '1em').style('font-size', params.titleFontSize).text(params.title);
    if (params.rightSankey) {
      this.drawTotal(params.rightSankey, data.metric[params.rightSankey].total, params.primaryTitleColor, 'right', width);
      new RightSankey_1.default(this.svg, this.tooltip, width, params.rootHeight, this.heightScale).draw({
        data: {
          [params.rightSankey]: data.metric[params.rightSankey]
        },
        params
      }, numSankeys);
    }
    if (params.leftSankey) {
      this.drawTotal(params.leftSankey, data.metric[params.leftSankey].total, params.secondaryTitleColor, 'left', width);
      let extraValue = 0;
      if (params.rightSankey && data.metric[params.rightSankey].total > data.metric[params.leftSankey].total) {
        extraValue = data.metric[params.rightSankey].total - data.metric[params.leftSankey].total;
      }
      const leftSankey = new LeftSankey_1.default(this.svg, this.tooltip, width, params.rootHeight, this.heightScale);
      if (params.rightSankey) {
        const leftSankeySpaces = lodash_1.default.keys(data.metric[params.leftSankey].children).filter(key => key !== 'sankey__extra').length - 1 + (extraValue ? 1 : 0);
        const rightSankeySpaces = lodash_1.default.keys(data.metric[params.rightSankey].children).length - 1;
        if (rightSankeySpaces > leftSankeySpaces) {
          leftSankey.betweenPadding = leftSankey.betweenPadding / leftSankeySpaces * rightSankeySpaces;
        }
      }
      leftSankey.draw({
        data: {
          [params.leftSankey]: data.metric[params.leftSankey]
        },
        params
      }, numSankeys, extraValue);
    }
    this.svg.attr('viewBox', `0 0 ${width} ${height - footerHeight}`);
  }
  drawTotal(name, value, color, side, width) {
    const x = side === 'right' ? width * 0.95 : width * 0.05;
    const g = this.svg.append('g').attr('class', `sankey-total sankey-total-${side}`).attr('transform', `translate(${x}, 0)`);
    g.append('text').attr('dy', '1em').classed('sankey-total-title', true).attr('fill', color).text(`Total ${name}`);
    g.append('text').classed('sankey-total-value', true).attr('dy', '1em').attr('y', 20).attr('fill', color).text(format_1.VALUE_FORMATS.dollars(value, {
      suffixLength: 'long'
    }));
  }
}
exports.default = SankeyDiagram;